<template>
  <div class="tree-box">
    <box :title="title"></box>
    <div class="chose">
      <slot name="chose"></slot>
    </div>
    <div class="box_body">
      <template v-if="showTree">
        <div class="tree">
          <div class="tree__title">
            <p>组织列表</p>
          </div>
          <div class="tree__isTree">
            <el-tree
              v-if="!isrent"
              :data="orgTree"
              ref="tree"
              node-key="deptId"
              highlight-current
              :default-checked-keys="[15]"
              default-expand-all
              @node-click="handleNodeClick"
              :props="defaultProps"
            ></el-tree>
            <el-tree
              v-if="isrent"
              :data="orgTree"
              ref="tree"
              node-key="districtId"
              highlight-current
              :default-checked-keys="[1]"
              :default-expanded-keys="[2]"
              @node-click="handleNodeClick"
              :props="defaultProps2"
            ></el-tree>
          </div>
        </div>
      </template>
      <template v-if="otherTree">
        <div class="tree">
          <slot name="tree"></slot>
        </div>
      </template>
      <div class="message">
        <slot name="message"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import box from "../../../component/box";
import Axios from "../../../../utils/Axios";
import Axios2 from "../../../../utils/Axios2";
export default {
  name: "treeBox",
  components: { box },
  props: {
    title: {
      default: "标题",
      type: String,
    },
    showTree: {
      default: false,
      type: Boolean,
    },
    isrent: {
      default: false,
      type: Boolean,
    },
    otherTree: {
      default: false,
      type: Boolean,
    },
    showFooter: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      orgTree: [],
      deptId: "",
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      defaultProps2: {
        children: "children",
        label: "name",
      },
      page: 1,
      sizePage: 10,
      totalSum: 0,
    };
  },
  methods: {
    handleNodeClick(row) {

      if(row.deptId){
        this.$emit("sendID", row.deptId);
      }else{
        this.$emit("sendID", row.districtId);
      }

    },
    getOrgTree() {
      const param = {};
      param.method = "get";
      param.url = "/dept/getDeptTree";
      param.params = {};
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.orgTree = res.data;
        }
      });
    },
    getOrgTree2() {
      const param = {};
      param.method = "post";
      param.url = "/system/web/v2/district/tree";
      param.datas = {};
      Axios2.ajax(param).then((res) => {
        if (res.data) {
          this.orgTree = res.data;

        }
      });
    },
  },
  created() {
    if(this.isrent){
      this.getOrgTree2()
    }else{
      this.getOrgTree();
    }

  },
};
</script>

<style lang="less" scoped>
.tree-box {
  margin-bottom: 24px;
  .box_body {
    min-height: 82vh;
    max-height: 92vh;
    margin-top: 14px;
    display: flex;
    .tree {
      width: 340px;
      margin-right: 14px;
      padding: 18px 12px 0 24px;
      background: #ffffff;
      border-radius: 4px;
      &__isTree {
        padding: 10px 0px;
        overflow: auto;
        height: 95%;
      }
    }
    .message {

      padding: 18px 36px 0 36px;
      background: #ffffff;
      border-radius: 4px;
      flex: 1;
    }
  }
}
</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
